import React from "react";

const weekDays = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
const hours = Array.from({ length: 24 }, (_, i) => i);

const timeToMinutes = (time) => {
    const [h, m] = time.split(":").map(Number);
    return h * 60 + m;
};

const formatHour = (h) => {
    if (h === 0) return "12 AM";
    if (h < 12) return `${h} AM`;
    if (h === 12) return "12 PM";
    return `${h - 12} PM`;
};

const formatDate = (date) =>
    `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(
        date.getDate()
    ).padStart(2, "0")}`;

const getWeekDates = (currentDate) => {
    const start = new Date(currentDate);
    start.setHours(0, 0, 0, 0);
    start.setDate(start.getDate() - start.getDay());

    return Array.from({ length: 7 }, (_, i) => {
        const d = new Date(start);
        d.setDate(start.getDate() + i);
        return d;
    });
};

const PX_PER_MINUTE = 2;

const OldWeekView = ({ currentDate, bookings }) => {
    const weekDates = getWeekDates(currentDate);

    return (
        <div className="week-wrapper">

            <div className="week-header-row">
                <div className="time-header">Time</div>
                {weekDates.map((date, i) => (
                    <div key={i} className="week-header-cell">
                        <div className="week-day">{weekDays[i]}</div>
                        <div className="week-date">{date.getDate()}</div>
                    </div>
                ))}
            </div>

            <div className="week-body">

                <div className="time-column">
                    {hours.map((h) => (
                        <div key={h} className="time-slot">
                            {formatHour(h)}
                        </div>
                    ))}
                </div>


                <div className="week-columns">
                    {weekDates.map((date, dayIndex) => {
                        const dateStr = formatDate(date);
                        const dayBookings = bookings.filter(
                            (b) => b.admin_date === dateStr
                        );

                        return (
                            <div key={dayIndex} className="day-column">

                                {hours.map((h) => (
                                    <div key={h} className="hour-cell" />
                                ))}


                                {dayBookings.map((b) => {
                                    const start =
                                        timeToMinutes(b.admin_start_time) * PX_PER_MINUTE;
                                    const end =
                                        timeToMinutes(b.admin_end_time) * PX_PER_MINUTE;

                                    return (
                                        <div
                                            key={b.consultation_booking_id}
                                            className={`booking ${b.booking_status}`}
                                            style={{
                                                top: `${start}px`,
                                                height: `${end - start}px`, cursor: 'pointer',
                                            }} onClick={() => window.open(b.meeting_link, '_blank')}

                                        >
                                            <div className="booking-title">{b.full_name}</div>
                                            <div className="booking-time">
                                                {b.admin_start_time.slice(0, 5)} –{" "}
                                                {b.admin_end_time.slice(0, 5)}
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};


export default OldWeekView;
